import React, {FC, ReactNode} from 'react'
import clsx from 'clsx'
import Loader, {LoaderVariant} from './Loader'

type CommerciumLoaderHostProps = {
  variant?: LoaderVariant
  /** Centered block with min-height (cards, tables). */
  layout?: 'centered' | 'inline' | 'row'
  compact?: boolean
  className?: string
  label?: ReactNode
}

const CommerciumLoaderHost: FC<CommerciumLoaderHostProps> = ({
  variant = 'section',
  layout = 'centered',
  compact = false,
  className,
  label,
}) => (
  <div
    className={clsx(
      'cmm-loader-host',
      layout === 'centered' && 'cmm-loader-host--centered',
      layout === 'inline' && 'cmm-loader-host--inline',
      layout === 'row' && 'cmm-loader-host--row',
      compact && 'cmm-loader-host--compact',
      className
    )}
    role='status'
    aria-live='polite'
  >
    <Loader variant={variant} />
    {label ? <span className='cmm-loader-host__label'>{label}</span> : null}
  </div>
)

export default CommerciumLoaderHost
